import { render } from "./Band.vue?vue&type=template&id=f652e7ec"
import script from "./Band.vue?vue&type=script&lang=js"
export * from "./Band.vue?vue&type=script&lang=js"

import "./Band.vue?vue&type=style&index=0&id=f652e7ec&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__